"use client";

import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { BASE_URL } from "../config/apiconfig";
const FaqContext = createContext(null);
export const useFaqs = () => {
  const context = useContext(FaqContext);
  if (!context) {
    throw new Error("useFaqs must be used within FaqProvider");
  }
  return context;
};

const FAQ_API = `${BASE_URL}/faqs`;

const normalizeFaq = (f) => ({
  id: String(f.id),
  question: f.question ?? "",
  answer: f.answer ?? "",
  status: f.status ?? "Inactive",
});


export const FaqProvider = ({ children }) => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchFaqs = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await fetch(FAQ_API);
      const data = await res.json();
// console.log(data)
      if (Array.isArray(data)) {
        setFaqs(data.map(normalizeFaq));
      } else if (data?.data && Array.isArray(data.data)) {
        setFaqs(data.data.map(normalizeFaq));
      } else {
        setFaqs([]);
      }
    } catch (err) {
      setError("Failed to load FAQs");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFaqs();
  }, [fetchFaqs]);

  return (
    <FaqContext.Provider value={{ faqs, loading, error }}>
      {children}
    </FaqContext.Provider>
  );
};
